
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'MediaSizer',
  props: {
    layout: {
      type: String as PropType<string>,
      default: 'responsive',
      validator: (value: string) => {
        return ['responsive', 'fixed'].indexOf(value) > -1
      }
    },
    width: {
      type: [String, Number] as PropType<number>,
      required: true
    },
    height: {
      type: [String, Number] as PropType<number>,
      required: true
    }
  },
  methods: {
    getPercent (): number {
      return (this.height / this.width * 100)
    }
  },
  computed: {
    cssVars () {
      return {
        '--sizer-percent': this.getPercent() + '%'
      }
    }
  }
})
